import { Platform, StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    contentCard: {
        width: 145,
        height: 192,
        backgroundColor: '#fff',
        borderTopLeftRadius: 20,
        borderBottomRightRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4.84,
        elevation: 5,
        marginTop: 30,
        paddingLeft: 12,
        paddingTop: 14,
        marginLeft: 20
    },
    contentHeaderCard: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    percentage: {
        width: 40,
        height: 40,
        borderWidth: 1,
        borderColor: "#000",
        borderRadius: 20,
        textAlign: 'center',
        textAlignVertical: 'center',
        fontWeight: 'bold',
        paddingTop: Platform.OS === 'ios' ? 10 : 0
    },
    textCashback: {
        color: '#196059',
        fontSize: 16,
        marginTop: 8,
        fontWeight: '500'
    },
    imgCashback: {
        width: 65,
        height: 110,
        position: 'absolute',
        right: 0,
        marginTop: 50
    },
    descriptionCashback: {
        fontSize: 10,
        width: 60,
        alignItems: 'center',
        marginTop: 25,
    },
    more: {
        fontSize: 14,
        position: 'absolute',
        bottom: 24,
        paddingLeft: 12
    }
});

export default styles;